import { HotPoint } from './hot-point.model';

export class ImageWithHotPoints {
  title: string = '';
  description: string = '';
  image: string = '';
  points: Array<HotPoint> = [];
}



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/products/shared/models/image-with-hot-points.model.ts